import Error from '../model/Error';
import axios from 'axios';

export default class ClubInvoicePdfRepository {
    static createClubInvoicePdfEmailHistory(clubInvoiceId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/club-invoice-pdfs/${clubInvoiceId}/email-history`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static createClubReverseInvoicePdfEmailHistory(clubReverseInvoiceId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/club-reverse-invoice-pdfs/${clubReverseInvoiceId}/email-history`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static createBulkPdfEmailHistories(clubId, invoiceIds, reverseInvoiceIds) {
        const data = { invoices: invoiceIds, reverseInvoices: reverseInvoiceIds };
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/club-invoice-pdfs/email-history`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
